import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {AddressFormatter, DateTimeFormatter} from "../../../utils/formatters";
import {activeFilter} from "../../../utils/filters";
import Select from "../../form/Select";

export default class InventoryList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "InventoryList"}
                {...props}
                columns={{
                    "store.name": {
                        header: 'Raktár',
                        width: 6,
                        sortable,
                        filterable
                    },
                    "type": {
                        header: "Típus",
                        width: 2,
                        sortable,
                        operator: '=',
                        filterable: <Select
                            isClearable={true}
                            options={Object.values(this.props.types)}
                            objectValue={false}
                            storeType="local"
                            label={false}
                            valueKey="value"
                            labelKey="label"
                        />,
                        renderer: (value, row) => this.props.types[value].label,
                    },
                    "date": {
                        header: 'Dátum',
                        width: 2,
                        sortable,
                        filterable,
                        renderer: DateTimeFormatter
                    },
                }}
                orderBy={{field: "date", direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}
